export const MANAGER_UNIT_CODE = 'MGR';

/** Mirrors the backend's UnitGroup.unit_code formula exactly. */
export function computeUnitCode(
  bedrooms: number,
  bathrooms: number | null,
  isManager: boolean,
): string {
  if (isManager) return MANAGER_UNIT_CODE;
  const bedPart = String(bedrooms * 10).padStart(2, '0');
  const bathPart =
    bathrooms === null ? 'XX' : String(Math.round(bathrooms * 10)).padStart(2, '0');
  return `${bedPart}-${bathPart}`;
}
